export const CRAM_MODE_MODULES_STUDY_LIMIT = 20;

export enum CramModeGating {
  modules20 = "multi-section-20-modules",
  hardestQuestions = "multi-section-hq"
}

export const CramModeGatingSessionMessage = `Get Seneca Exam Boost to access unlimited cram mode & speed test your knowledge across multiple topics.`;
